export const KEYS = [
  'C',
  'C#',
  'D',
  'D#',
  'E',
  'F',
  'F#',
  'G',
  'G#',
  'A',
  'A#',
  'B',
];

export type Key = (typeof KEYS)[number];

export const KEYBOARD_LAYOUT = {
  Q: 'C4',
  2: 'C#4',
  W: 'D4',
  3: 'D#4',
  E: 'E4',
  R: 'F4',
  5: 'F#4',
  T: 'G4',
  6: 'G#4',
  Y: 'A4',
  7: 'A#4',
  U: 'B4',
  I: 'C5',
  9: 'C#5',
  O: 'D5',
  0: 'D#5',
  P: 'E5',

  Z: 'C3',
  S: 'C#3',
  X: 'D3',
  D: 'D#3',
  C: 'E3',
  V: 'F3',
  G: 'F#3',
  B: 'G3',
  H: 'G#3',
  N: 'A3',
  J: 'A#3',
  M: 'B3',
  ',': 'C4',
  L: 'C#4',
  '.': 'D4',
  ';': 'D#4',
  '/': 'E4',
};

export const OSCILLOSCOPE_KEYS = [
  'Q', // 'C4',
  'E', // 'E4',
  'Y', // 'A4',
  'R', // 'F4',
  'U', // 'B4',
  'Z', // 'C3',
  'C', // 'E3',
  'N', // 'A3',
  'V', // 'F3',
  'M', // 'B3',
];
